import { Controller } from "@hotwired/stimulus";
import { Bubble } from "../lib/bubble";

/**
 * Une bulle de BD permanente qui POINTE un élément (lib/bubble, sorte `callout`) — pas un
 * tooltip : elle reste affichée tant que son marqueur existe.
 *
 * L'élément du contrôleur n'est qu'un marqueur (rendu serveur, là où le morph le gère) : la
 * bulle vit dans le <body>. Le marqueur disparaît (morph, frame rechargé) → la bulle aussi.
 *
 * Usage :
 *   <span hidden data-controller="callout"
 *         data-callout-anchor-value="dom_id_of_target"
 *         data-callout-text-value="L'image doit être personnalisée avant d'être publiée"
 *         data-callout-placement-value="top"></span>
 *
 * `data-callout-duration-value` (ms) : une bulle de passage, qui s'efface seule — et au
 * premier clic sur ce qu'elle pointe.
 */
export default class extends Controller {
  static values = { anchor: String, text: String, placement: { type: String, default: "top" }, duration: Number };

  connect() {
    const anchor = document.getElementById(this.anchorValue);
    if (!anchor) return;
    this.bubble = new Bubble(anchor, { kind: "callout", text: this.textValue, placement: this.placementValue });
    if (!this.durationValue) return;

    this.dismiss = () => this.disconnect();
    this.timer = setTimeout(this.dismiss, this.durationValue);
    anchor.addEventListener("pointerdown", this.dismiss, { once: true });
    this.anchor = anchor;
  }

  disconnect() {
    clearTimeout(this.timer);
    this.anchor?.removeEventListener("pointerdown", this.dismiss);
    this.bubble?.dismiss();
    this.bubble = null;
  }
}
